import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Site } from 'src/app/classes/models';
import { GenericObject } from 'src/app/interfaces/generic-object';
import { SiteService } from 'src/app/services/site.service';
import { ToastService } from 'src/app/services/toast.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-admin-client-site-details-modal',
  templateUrl: './admin-client-site-details-modal.component.html',
  styleUrl: './admin-client-site-details-modal.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AdminClientSiteDetailsModalComponent implements OnInit {
  constructor(
    private activeModal: NgbActiveModal,
    private SiteService: SiteService,
    private UtilityService: UtilityService,
    private ToastService: ToastService,
    private ChangeDetectorRef: ChangeDetectorRef
  ) {}

  @Input() SiteId?: number;
  @Input() CompanyId?: number;

  siteMap?: Map<string, string | number | null>;
  Site?: Site;
  suppliedGridQueryData: GenericObject = {};

  keyValuePairDefaultOrder = this.UtilityService.keyValuePairDefaultOrder;

  close() {
    this.activeModal.dismiss('Cross Click');
  }

  loadData() {
    if (!this.SiteId) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Cannot load site details. No Site ID found.',
        { returnError: true }
      );
    }

    if (!this.CompanyId) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Cannot load site details. No Company ID found.',
        { returnError: true }
      );
    }

    const siteQuery = {
      id: this.SiteId,
      CompanyId: this.CompanyId,
      attributes: [
        'siteKey',
        'legalName',
        'dba',
        'phone',
        'fax',
        'ein',
        'units'
      ],
      StreetAddress: {
        attributes: ['address1', 'address2', 'city', 'state', 'zip']
      },
      Contact: {},
      SiteVendor: {}
    };

    this.SiteService.getSite(
      this.UtilityService.stringifyObjectsInQueryObject(siteQuery)
    ).subscribe({
      next: (Site: Site) => {
        this.Site = Site;

        const {
          siteKey,
          legalName,
          dba,
          phone,
          fax,
          ein,
          units,
          StreetAddress,
          SiteVendors
        } = this.Site;

        if (SiteVendors) {
          const siteVendorIdArr = SiteVendors.map((sv) => sv.id);

          Object.assign(this.suppliedGridQueryData, {
            id: { $in: siteVendorIdArr }
          });
        }

        this.siteMap = new Map<string, number | string | null>([
          ['Site Key', siteKey || ''],
          ['Site Name', legalName || ''],
          ['DBA', dba || ''],
          ['Phone', phone || ''],
          ['Fax', fax || ''],
          ['EIN(Tax ID)', ein || ''],
          ['Unit Count', units || ''],
          ['', ''],
          ['Address', StreetAddress?.address1 || ''],
          ['City', StreetAddress?.city || ''],
          ['State', StreetAddress?.state || ''],
          ['Zip', StreetAddress?.zip || '']
        ]);
        this.ChangeDetectorRef.markForCheck();
      }
    });
  }

  ngOnInit(): void {
    this.loadData();
  }
}
